import { axios } from "@Root/API";

export const deleteAttachment = attachmentId => {
  return axios.delete(`delete/attachment/${attachmentId}`);
};
